import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { logIn } from '../actions/LoginAction';
import isNull from '../utils/NullChecking';
import NotificationHandler from '../utils/NotificationHandler';
import { enumUtil } from '../utils/Enum';

const useHandleSwitchPractice = () => {
    let dispatch = useDispatch()
    const switchPractice = Cookies.get('SwitchPracticeToken');
    if(!isNull(switchPractice)){
        if(switchPractice !== Cookies.get('cookedToken')){
            dispatch(logIn({ token: switchPractice })) 
            Cookies.set('cookedToken', switchPractice, { expires: 1 })
            Cookies.set('SwitchPracticeToken','',{ expires: 1 }) 
            NotificationHandler("Changes applied suceesfully", enumUtil.enumtoaster.success)
        }
    }
}
 
export default useHandleSwitchPractice;